// Plugin Vue 2 pour vue-i18n
// Remplace toutes les occurrences de "Sinao" par appName dans les traductions

const I18nTranslate = {
	install(Vue, { i18n, appName = "App", brand = "Sinao" } = {}) {
		if (!i18n || typeof i18n.t !== "function") {
			if (process && process.env && process.env.NODE_ENV !== "production") {
				// eslint-disable-next-line no-console
				console.error("[i18n-translate] i18n introuvable ou invalide. Passe { i18n } lors du Vue.use().");
			}
			return;
		}

		if (appName === brand) {
			// Rien à remplacer, on s’arrête proprement
			return;
		}

		// Sauvegarde de la méthode d’origine
		const originalT = i18n.t.bind(i18n);

		// Patch de i18n.t()
		i18n.t = function patchedT(key, ...args) {
			const out = originalT(key, ...args);
			if (typeof out !== "string") return out;
			// Remplacement global sans dépendre de String.prototype.replaceAll
			// (pour compat IE11/anciens builds si besoin)
			return out.split(brand).join(appName);
		};

		// Assure que this.$t et Vue.prototype.$t passent par i18n.t patché
		// (dans la majorité des cas vue-i18n le fait déjà, mais on force pour être sûr)
		Vue.prototype.$t = function (key, ...args) {
			return i18n.t(key, ...args);
		};
	}
};

export default I18nTranslate;
